/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalFormProvider } from './';
import {
    LegalFormProviderFromJSON,
    LegalFormProviderFromJSONTyped,
    LegalFormProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalFormsMapping
 */
export interface LegalFormsMapping {
    /**
     * 
     * @type {string}
     * @memberof LegalFormsMapping
     */
    providerLegalForm: string;
    /**
     * 
     * @type {LegalFormProvider}
     * @memberof LegalFormsMapping
     */
    provider: LegalFormProvider;
    /**
     * 
     * @type {string}
     * @memberof LegalFormsMapping
     */
    legalFormName: string;
    /**
     * 
     * @type {string}
     * @memberof LegalFormsMapping
     */
    companyTypeId: string;
}

/**
 * Check if a given object implements the LegalFormsMapping interface.
 */
export function instanceOfLegalFormsMapping(value: object): value is LegalFormsMapping {
    if (!('providerLegalForm' in value) || value['providerLegalForm'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('legalFormName' in value) || value['legalFormName'] === undefined) return false;
    if (!('companyTypeId' in value) || value['companyTypeId'] === undefined) return false;
    return true;
}

export function LegalFormsMappingFromJSON(json: any): LegalFormsMapping {
    return LegalFormsMappingFromJSONTyped(json, false);
}

export function LegalFormsMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalFormsMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'providerLegalForm': json['providerLegalForm'],
        'provider': LegalFormProviderFromJSON(json['provider']),
        'legalFormName': json['legalFormName'],
        'companyTypeId': json['companyTypeId'],
    };
}

export function LegalFormsMappingToJSON(value?: LegalFormsMapping | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'providerLegalForm': value['providerLegalForm'],
        'provider': LegalFormProviderToJSON(value['provider']),
        'legalFormName': value['legalFormName'],
        'companyTypeId': value['companyTypeId'],
    };
}

